import React from 'react';
import HealthPackagesHero from '../components/health-packages/HealthPackagesHero';
import PackagesIntro from '../components/health-packages/PackagesIntro';
import PackageGrid from '../components/health-packages/PackageGrid';
import PackageCTA from '../components/health-packages/PackageCTA';

const HealthPackages = () => {
  return (
    <div className="health-packages-page">
      <HealthPackagesHero />
      <PackagesIntro />
      <PackageGrid />
      <PackageCTA />
    </div>
  );
};

export default HealthPackages;